import { render, staticRenderFns } from "./LeftoversList.vue?vue&type=template&id=35d419e8&scoped=true&"
import script from "./LeftoversList.vue?vue&type=script&lang=js&"
export * from "./LeftoversList.vue?vue&type=script&lang=js&"
import style0 from "./LeftoversList.vue?vue&type=style&index=0&id=35d419e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d419e8",
  null
  
)

export default component.exports